import React from "react";
import { ContentSyncWidgetTemplate } from "themes/administration/content-sync/components";

function ContentSyncWidget(props) {
    return <ContentSyncWidgetTemplate {...props} />;
}

export default ContentSyncWidget;
